export default __webpack_public_path__ + "static/media/clock-five.d0f27059.svg";